import { render, staticRenderFns } from "./Studentarchievement.vue?vue&type=template&id=2e51a336"
import script from "./Studentarchievement.vue?vue&type=script&lang=js"
export * from "./Studentarchievement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports